// extracted by mini-css-extract-plugin
module.exports = {"main":"IconButton__main___Sj00J"};